
import { ADD_ARTICLE, UPDATE_BACK_STAKE_SETTINGS, UPDATE_COMMISSION_SETTINGS, UPDATE_DISPLAY_CONFIRM_NOX, UPDATE_LAY_STAKE_SETTINGS, UPDATE_STAKE_SETTINGS, UPDATE_TOKEN } from "../constants/action-types";
import { UPDATE_TIME_SETTINGS } from "../constants/action-types";
import { UPDATE_TIME_SETTINGS_ONE_BY_ONE } from "../constants/action-types";
import { UPDATE_ALL_COUNTRY_LIST } from "../constants/action-types";
import { UPDATE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import { ADD_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import { REMOVE_FILTERED_COUNTRY_LIST } from "../constants/action-types";
import {UPDATE_CURRENT_RACE_TIME} from "../constants/action-types";
import {UPDATE_T0_SETTINGS} from "../constants/action-types";
import {RUNNERS_ODDS_AT_TIMES} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE} from "../constants/action-types";
import {UPDATE_EXACT_TIME_SETTINGS} from "../constants/action-types";
import {UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE} from "../constants/action-types";
import {IS_REFRESHED} from "../constants/action-types";
import {STEAMER_MIN_PRICE} from "../constants/action-types";
import {STEAMER_MAX_PRICE} from "../constants/action-types";
import {DRIFTER_MIN_PRICE} from "../constants/action-types";
import {DRIFTER_MAX_PRICE} from "../constants/action-types";
import {MIN_VOLUME} from "../constants/action-types";
import {UPDATE_STEAMER_DRIFTER_SETTINGS} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_OFFSET_TO_GMT} from "../constants/action-types";
import {UPDATE_LOCAL_TIME_ZONE} from "../constants/action-types";
import {UPDATE_LATEST_ODDS_SETTINGS} from "../constants/action-types";
import {SET_CUSTOM_SETTINGS_STATE} from "../constants/action-types";
import {UPDATE_BET_MARKET} from "../constants/action-types";

import moment from 'moment';
import momentz from 'moment-timezone';

const intialState = {
  isRefreshed: false,
  articles: [],
  latestOddsSettings: {
    tickUntilActualStart: "yes",
    noOfSeconds: "10",
    commision: "5",
    backStake: "0.1",
    layStake: "0.1"
  },
  customSettingsState: {
    displayTicks: true
  },
  currentBets: [],
  clearedBets:[],
  loginToken: "",
  t0Settings:{
    option:"exact",
    diff:"0",
    exact:moment().tz("Etc/GMT"),
  },
  timeSettings:{
    t1: "20:00",
    t2: "10:00",
    t3: "05:00",
    t4: "03:00",
    t5: "02:00",
    t6: "01:00",
    t0: "00:05"
  },
  exactTimeSettings:{
    t1: "01:30",
    t2: "01:45",
    t3: "02:00",
    t4: "02:30",
    t5: "03:00",
    t6: "04:00",
    t0: "00:00"

  },
  isExactTimeSelected:{
    t1: "diff",
    t2: "diff",
    t3: "diff",
    t4: "diff",
    t5: "diff",
    t6: "diff",
    t0: "exact"
  },
  allCountryList:[],
  allCountryList2:{
    UK:"GB",
    IRE:"IE",
    AUS:"AU",
    NZ:"NZ",
    //RSA:"ZA",
    //HKG:"HK",
    //USA:"US",
    //SWE:"SE",
    // JPN:"JP",
    //DEU:"DE",
    //FRA:"FR",
    //SGP:"SG"
  },
  //filteredCountryList:["GB","IE","AU","NZ","US"],
  filteredCountryList:["GB","IE","AU","NZ"],
  fullCountryName:{
    GB:"Great Britain",
    IR:"Iran",
    AU:"Australia",
    FR:"France",
    US:"United States",
    CL:"Chile",
    IE:"Ireland",
    NZ:"New Zealand",
    ZA:"South Africa",
    US:"United States",
    SE:"Sweden",
    // JP:"Japan",
    DE:"Germany",
    FR:"France",
    SG:"Singapore"
  },
  StearmerDrifterSettings:{
    STEAMER_MIN_PRICE:"1.50",
    STEAMER_MAX_PRICE:"10.00",
    DRIFTER_MIN_PRICE:"1.50",
    DRIFTER_MAX_PRICE:"10.00",
    MIN_VOLUME:"5000"
  },
  runnersOddsAtTimes:[],
  currentRaceTime: moment(),
  localTimeOffSetToGmt: 60,
  localTimeZone: "GMT+01:00",
  displayConfirmBox: true, 
  betMarket: null
};


function rootReducer(state = intialState, action){
  if (action.type === ADD_ARTICLE) {
    return Object.assign({}, state, {
      articles: state.articles.concat(action.payload)
    });
  }
  else if(action.type === UPDATE_TIME_SETTINGS){
    return Object.assign({}, state, {
      timeSettings: action.payload
    });
  }
  else if(action.type === UPDATE_TIME_SETTINGS_ONE_BY_ONE){
    let object = state.timeSettings
    //console.log("FFZFF UPDATE_TIME_SETTINGS_ONE_BY_ONE "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        timeSettings: object
      });
    }

  }
  else if(action.type === UPDATE_EXACT_TIME_SETTINGS){
    return Object.assign({}, state, {
      exactTimeSettings: action.payload
    });
  }
  else if(action.type === UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE){
    let object = state.exactTimeSettings
    //log("FFZFF UPDATE_EXACT_TIME_SETTINGS_ONE_BY_ONE "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        exactTimeSettings: object
      });
    }
  }
  else if(action.type === UPDATE_BET_MARKET){
    return Object.assign({}, state, {
      betMarket: action.payload
    });
  }

  else if(action.type === UPDATE_ALL_COUNTRY_LIST){
    return Object.assign({}, state, {
      allCountryList: action.payload
    });
  }
  else if(action.type === UPDATE_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: action.payload
    });
  }
  else if(action.type === ADD_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: state.filteredCountryList.concat(action.payload)
    });
  }
  else if(action.type === REMOVE_FILTERED_COUNTRY_LIST){
    return Object.assign({}, state, {
      filteredCountryList: state.filteredCountryList.filter(data => data!=action.payload)
    });
  }
  else if(action.type === UPDATE_CURRENT_RACE_TIME){
    return Object.assign({}, state, {
      currentRaceTime: action.payload
    });
  }
  else if(action.type === UPDATE_T0_SETTINGS){
    let object = state.t0Settings
    //console.log("FFZFF "+action.payload.option + " value "+action.payload.value);
    if(action.payload.value !== undefined){
    object[action.payload.id] = action.payload.value
    return Object.assign({}, state, {
      t0Settings: object
    });
  }
  }
  else if(action.type === RUNNERS_ODDS_AT_TIMES){
    return Object.assign({}, state, {
      runnersOddsAtTimes: action.payload
    });
  }
  else if(action.type === IS_REFRESHED){
    return Object.assign({}, state, {
      isRefreshed: action.payload
    });
  }
  else if(action.type === UPDATE_IS_EXACT_TIME_SELECTED_ONE_BY_ONE){
    let object = state.isExactTimeSelected
    //console.log("IS EXACT TIME SELECTED: "+action.payload.id + " value "+action.payload.value);
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        isExactTimeSelected: object
      });
    }
  }
  else if(action.type === UPDATE_STEAMER_DRIFTER_SETTINGS){
    let object = state.StearmerDrifterSettings
    if(action.payload.value !== undefined){
    //console.log("Steamer Drifter Settings : "+action.payload.id + " value "+action.payload.value);
    object[action.payload.id] = action.payload.value
    return Object.assign({}, state, {
      StearmerDrifterSettings: object
    });
  }
  }
  else if(action.type === UPDATE_LOCAL_TIME_OFFSET_TO_GMT){
    //console.log("UPDATE_LATEST_ODDS_SETTINGS: "+ action.payload.id + " value "+action.payload.value);
    return Object.assign({}, state, {
      localTimeOffSetToGmt: action.payload
    });
  }
  else if(action.type === SET_CUSTOM_SETTINGS_STATE){
    //log("SET_CUSTOM_SETTINGS_STATE: value "+action.payload);
    //console.log(action.payload)
    return Object.assign({}, state, {
      customSettingsState: action.payload
    });
  }
  
  else if(action.type === UPDATE_LOCAL_TIME_ZONE){
    return Object.assign({}, state, {
      localTimeZone: action.payload
    });
  }
  else if(action.type === UPDATE_LATEST_ODDS_SETTINGS){
    let object = state.latestOddsSettings
    if(action.payload.value !== undefined){
      //log("UPDATE_LATEST_ODDS_SETTINGS: "+ action.payload.id + " value "+action.payload.value);
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        latestOddsSettings: object
      });
    }
  }
  else if(action.type === UPDATE_COMMISSION_SETTINGS
    ||action.type === UPDATE_BACK_STAKE_SETTINGS
    || action.type === UPDATE_LAY_STAKE_SETTINGS){
    let object = state.latestOddsSettings
    if(action.payload.value !== undefined){
      object[action.payload.id] = action.payload.value
      return Object.assign({}, state, {
        latestOddsSettings: object
      });
    }
  }
  else if(action.type === UPDATE_TOKEN){
    return Object.assign({}, state, {
        loginToken: action.payload
      });
    }
    else if(action.type === UPDATE_DISPLAY_CONFIRM_NOX){
      return Object.assign({}, state, {
          displayConfirmBox: action.payload
        });
      }  
  return state;
}

export default rootReducer
